<!-- 期刊简介 -->
<template>
  <div class=''>
    <van-nav-bar title="期刊简介"
                 left-arrow
                 :fixed="true"
                 @click-left="$router.go(-1)" />
    <div class="content" v-html="info.periodicalIntro">
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      info: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getInfo() {
      this.$apis.hundredServe.bkDetailList({
        id: this.$route.query.userId
      }).then((result) => {
        console.log(result)
        this.info = result.periodicalInfo
      }).catch((err) => {
        console.log(err)
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  padding: 60px 16px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
::v-deep .van-nav-bar__title {
  margin-left: 34px;
}
::v-deep.van-nav-bar .van-icon {
  color: #666666;
}
::v-deep .van-nav-bar__title {
  font-weight: 900;
}
</style>